import { render } from "./AdministrationWrongPrivileges.vue?vue&type=template&id=149bc409"
import script from "./AdministrationWrongPrivileges.vue?vue&type=script&lang=js"
export * from "./AdministrationWrongPrivileges.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__